// /api/userService.js
import axios from './axiosInstance';

export default {
  getUserProfile() {
    return axios.get('/account/me');
  },
  getAllUsers() {
    return axios.get('/account/all');
  },
  updateUserProfile(updatedData) {
    return axios.patch('/account/me', updatedData);
  },
  uploadProfileImage(imageData) {
    const formData = new FormData();
    formData.append('file', imageData);
    return axios.post('/account/upload_profile_image', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  },
  removeProfileImage() {
    return axios.delete('/account/remove_profile_image');
  },
  submitContactMessage(messageData) {
    return axios.post('/contact_us/', messageData);
  },
};
